/** 描画中のレッスン id（テレメトリ recordLessonIssue に渡す。lesson-format.md §5.3） */
import { getContext, setContext } from 'svelte';
import { lessonLinkTarget, type LessonLinkTarget } from './link';

const KEY = Symbol('lesson-id');
const LINK_KEY = Symbol('link-target');

export function setLessonId(id: string): void {
  setContext(KEY, id);
}

export function getLessonId(): string {
  const id: unknown = getContext(KEY);
  return typeof id === 'string' ? id : '';
}

/** リンク先の検査（許可しなければ null）。既定はレッスンの規則（lesson-format.md §5.4） */
export type LinkTargetCheck = (url: string) => LessonLinkTarget | null;

/**
 * 木の中のリンクを確かめる関数を差し替える（問題の画面は problemLinkTarget。problem-format.md §5.3）。
 * InlineNodes はこれを読む。
 */
export function setLinkTargetCheck(check: LinkTargetCheck): void {
  setContext(LINK_KEY, check);
}

export function getLinkTargetCheck(): LinkTargetCheck {
  const check: unknown = getContext(LINK_KEY);
  return typeof check === 'function' ? (check as LinkTargetCheck) : lessonLinkTarget;
}
